var map = {
	"./determine/Detoxification.jpg": 5175,
	"./determine/Hydration.jpg": 1232,
	"./determine/MentalFitness.jpg": 1437,
	"./determine/Movement.jpg": 6645,
	"./determine/Nature.jpg": 1123,
	"./determine/Nutrition.jpg": 3770,
	"./determine/Relationships.jpg": 553,
	"./determine/RestSelfCare.jpg": 7029,
	"./determine/Sleep.jpg": 1884,
	"./determine/Vision.jpg": 3801
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4613;